export default "__VITE_ASSET__C3H3lFns__"